// import { CircleFlag } from 'react-circle-flags';

export const countryCodes = [
  { code: 'ad', dial_code: '+376', name: 'Andorra' },
  { code: 'ae', dial_code: '+971', name: 'United Arab Emirates' },
  { code: 'af', dial_code: '+93', name: 'Afghanistan' },
  { code: 'ag', dial_code: '+1-268', name: 'Antigua and Barbuda' },
  { code: 'ai', dial_code: '+1-264', name: 'Anguilla' },
  { code: 'al', dial_code: '+355', name: 'Albania' },
  { code: 'am', dial_code: '+374', name: 'Armenia' },
  { code: 'ao', dial_code: '+244', name: 'Angola' },
  { code: 'ar', dial_code: '+54', name: 'Argentina' },
  { code: 'as', dial_code: '+1-684', name: 'American Samoa' },
  { code: 'at', dial_code: '+43', name: 'Austria' },
  { code: 'au', dial_code: '+61', name: 'Australia' },
  { code: 'aw', dial_code: '+297', name: 'Aruba' },
  { code: 'ax', dial_code: '+358-18', name: 'Åland Islands' },
  { code: 'az', dial_code: '+994', name: 'Azerbaijan' },
  { code: 'ba', dial_code: '+387', name: 'Bosnia and Herzegovina' },
  { code: 'bb', dial_code: '+1-246', name: 'Barbados' },
  { code: 'bd', dial_code: '+880', name: 'Bangladesh' },
  { code: 'be', dial_code: '+32', name: 'Belgium' },
  { code: 'bf', dial_code: '+226', name: 'Burkina Faso' },
  { code: 'bg', dial_code: '+359', name: 'Bulgaria' },
  { code: 'bh', dial_code: '+973', name: 'Bahrain' },
  { code: 'bi', dial_code: '+257', name: 'Burundi' },
  { code: 'bj', dial_code: '+229', name: 'Benin' },
  { code: 'bl', dial_code: '+590', name: 'Saint Barthélemy' },
  { code: 'bm', dial_code: '+1-441', name: 'Bermuda' },
  { code: 'bn', dial_code: '+673', name: 'Brunei' },
  { code: 'bo', dial_code: '+591', name: 'Bolivia' },
  { code: 'bq', dial_code: '+599', name: 'Caribbean Netherlands' },
  { code: 'br', dial_code: '+55', name: 'Brazil' },
  { code: 'bs', dial_code: '+1-242', name: 'Bahamas' },
  { code: 'bt', dial_code: '+975', name: 'Bhutan' },
  { code: 'bw', dial_code: '+267', name: 'Botswana' },
  { code: 'by', dial_code: '+375', name: 'Belarus' },
  { code: 'bz', dial_code: '+501', name: 'Belize' },
  { code: 'ca', dial_code: '+1', name: 'Canada' },
  { code: 'cc', dial_code: '+61', name: 'Cocos (Keeling) Islands' },
  { code: 'cd', dial_code: '+243', name: 'Democratic Republic of the Congo' },
  { code: 'cf', dial_code: '+236', name: 'Central African Republic' },
  { code: 'cg', dial_code: '+242', name: 'Republic of the Congo' },
  { code: 'ch', dial_code: '+41', name: 'Switzerland' },
  { code: 'ci', dial_code: '+225', name: 'Ivory Coast' },
  { code: 'ck', dial_code: '+682', name: 'Cook Islands' },
  { code: 'cl', dial_code: '+56', name: 'Chile' },
  { code: 'cm', dial_code: '+237', name: 'Cameroon' },
  { code: 'cn', dial_code: '+86', name: 'China' },
  { code: 'co', dial_code: '+57', name: 'Colombia' },
  { code: 'cr', dial_code: '+506', name: 'Costa Rica' },
  { code: 'cu', dial_code: '+53', name: 'Cuba' },
  { code: 'cv', dial_code: '+238', name: 'Cape Verde' },
  { code: 'cw', dial_code: '+599', name: 'Curaçao' },
  { code: 'cx', dial_code: '+61', name: 'Christmas Island' },
  { code: 'cy', dial_code: '+357', name: 'Cyprus' },
  { code: 'cz', dial_code: '+420', name: 'Czech Republic' },
  { code: 'de', dial_code: '+49', name: 'Germany' },
  { code: 'dj', dial_code: '+253', name: 'Djibouti' },
  { code: 'dk', dial_code: '+45', name: 'Denmark' },
  { code: 'dm', dial_code: '+1-767', name: 'Dominica' },
  { code: 'do', dial_code: '+1-809', name: 'Dominican Republic' },
  { code: 'dz', dial_code: '+213', name: 'Algeria' },
  { code: 'ec', dial_code: '+593', name: 'Ecuador' },
  { code: 'ee', dial_code: '+372', name: 'Estonia' },
  { code: 'eg', dial_code: '+20', name: 'Egypt' },
  { code: 'er', dial_code: '+291', name: 'Eritrea' },
  { code: 'es', dial_code: '+34', name: 'Spain' },
  { code: 'et', dial_code: '+251', name: 'Ethiopia' },
  { code: 'fi', dial_code: '+358', name: 'Finland' },
  { code: 'fj', dial_code: '+679', name: 'Fiji' },
  { code: 'fk', dial_code: '+500', name: 'Falkland Islands' },
  { code: 'fm', dial_code: '+691', name: 'Micronesia' },
  { code: 'fo', dial_code: '+298', name: 'Faroe Islands' },
  { code: 'fr', dial_code: '+33', name: 'France' },
  { code: 'ga', dial_code: '+241', name: 'Gabon' },
  { code: 'gb', dial_code: '+44', name: 'United Kingdom' },
  { code: 'gd', dial_code: '+1-473', name: 'Grenada' },
  { code: 'ge', dial_code: '+995', name: 'Georgia' },
  { code: 'gf', dial_code: '+594', name: 'French Guiana' },
  { code: 'gh', dial_code: '+233', name: 'Ghana' },
  { code: 'gi', dial_code: '+350', name: 'Gibraltar' },
  { code: 'gl', dial_code: '+299', name: 'Greenland' },
  { code: 'gm', dial_code: '+220', name: 'Gambia' },
  { code: 'gn', dial_code: '+224', name: 'Guinea' },
  { code: 'gp', dial_code: '+590', name: 'Guadeloupe' },
  { code: 'gq', dial_code: '+240', name: 'Equatorial Guinea' },
  { code: 'gr', dial_code: '+30', name: 'Greece' },
  { code: 'gt', dial_code: '+502', name: 'Guatemala' },
  { code: 'gu', dial_code: '+1-671', name: 'Guam' },
  { code: 'gw', dial_code: '+245', name: 'Guinea-Bissau' },
  { code: 'gy', dial_code: '+592', name: 'Guyana' },
  { code: 'hk', dial_code: '+852', name: 'Hong Kong' },
  { code: 'hn', dial_code: '+504', name: 'Honduras' },
  { code: 'hr', dial_code: '+385', name: 'Croatia' },
  { code: 'ht', dial_code: '+509', name: 'Haiti' },
  { code: 'hu', dial_code: '+36', name: 'Hungary' },
  { code: 'id', dial_code: '+62', name: 'Indonesia' },
  { code: 'ie', dial_code: '+353', name: 'Ireland' },
  { code: 'il', dial_code: '+972', name: 'Israel' },
  { code: 'im', dial_code: '+44', name: 'Isle of Man' },
  { code: 'in', dial_code: '+91', name: 'India' },
  { code: 'iq', dial_code: '+964', name: 'Iraq' },
  { code: 'ir', dial_code: '+98', name: 'Iran' },
  { code: 'is', dial_code: '+354', name: 'Iceland' },
  { code: 'it', dial_code: '+39', name: 'Italy' },
  { code: 'jm', dial_code: '+1-876', name: 'Jamaica' },
  { code: 'jo', dial_code: '+962', name: 'Jordan' },
  { code: 'jp', dial_code: '+81', name: 'Japan' },
  { code: 'ke', dial_code: '+254', name: 'Kenya' },
  { code: 'kg', dial_code: '+996', name: 'Kyrgyzstan' },
  { code: 'kh', dial_code: '+855', name: 'Cambodia' },
  { code: 'ki', dial_code: '+686', name: 'Kiribati' },
  { code: 'km', dial_code: '+269', name: 'Comoros' },
  { code: 'kn', dial_code: '+1-869', name: 'Saint Kitts and Nevis' },
  { code: 'kp', dial_code: '+850', name: 'North Korea' },
  { code: 'kr', dial_code: '+82', name: 'South Korea' },
  { code: 'kw', dial_code: '+965', name: 'Kuwait' },
  { code: 'ky', dial_code: '+1-345', name: 'Cayman Islands' },
  { code: 'kz', dial_code: '+7', name: 'Kazakhstan' },
  { code: 'la', dial_code: '+856', name: 'Laos' },
  { code: 'lb', dial_code: '+961', name: 'Lebanon' },
  { code: 'lc', dial_code: '+1-758', name: 'Saint Lucia' },
  { code: 'li', dial_code: '+423', name: 'Liechtenstein' },
  { code: 'lk', dial_code: '+94', name: 'Sri Lanka' },
  { code: 'lr', dial_code: '+231', name: 'Liberia' },
  { code: 'ls', dial_code: '+266', name: 'Lesotho' },
  { code: 'lt', dial_code: '+370', name: 'Lithuania' },
  { code: 'lu', dial_code: '+352', name: 'Luxembourg' },
  { code: 'lv', dial_code: '+371', name: 'Latvia' },
  { code: 'ly', dial_code: '+218', name: 'Libya' },
  { code: 'ma', dial_code: '+212', name: 'Morocco' },
  { code: 'mc', dial_code: '+377', name: 'Monaco' },
  { code: 'md', dial_code: '+373', name: 'Moldova' },
  { code: 'me', dial_code: '+382', name: 'Montenegro' },
  { code: 'mf', dial_code: '+590', name: 'Saint Martin' },
  { code: 'mg', dial_code: '+261', name: 'Madagascar' },
  { code: 'mh', dial_code: '+692', name: 'Marshall Islands' },
  { code: 'mk', dial_code: '+389', name: 'North Macedonia' },
  { code: 'ml', dial_code: '+223', name: 'Mali' },
  { code: 'mm', dial_code: '+95', name: 'Myanmar' },
  { code: 'mn', dial_code: '+976', name: 'Mongolia' },
  { code: 'mo', dial_code: '+853', name: 'Macao' },
  { code: 'mp', dial_code: '+1-670', name: 'Northern Mariana Islands' },
  { code: 'mq', dial_code: '+596', name: 'Martinique' },
  { code: 'mr', dial_code: '+222', name: 'Mauritania' },
  { code: 'ms', dial_code: '+1-664', name: 'Montserrat' },
  { code: 'mt', dial_code: '+356', name: 'Malta' },
  { code: 'mu', dial_code: '+230', name: 'Mauritius' },
  { code: 'mv', dial_code: '+960', name: 'Maldives' },
  { code: 'mw', dial_code: '+265', name: 'Malawi' },
  { code: 'mx', dial_code: '+52', name: 'Mexico' },
  { code: 'my', dial_code: '+60', name: 'Malaysia' },
  { code: 'mz', dial_code: '+258', name: 'Mozambique' },
  { code: 'na', dial_code: '+264', name: 'Namibia' },
  { code: 'nc', dial_code: '+687', name: 'New Caledonia' },
  { code: 'ne', dial_code: '+227', name: 'Niger' },
  { code: 'nf', dial_code: '+672', name: 'Norfolk Island' },
  { code: 'ng', dial_code: '+234', name: 'Nigeria' },
  { code: 'ni', dial_code: '+505', name: 'Nicaragua' },
  { code: 'nl', dial_code: '+31', name: 'Netherlands' },
  { code: 'no', dial_code: '+47', name: 'Norway' },
  { code: 'np', dial_code: '+977', name: 'Nepal' },
  { code: 'nr', dial_code: '+674', name: 'Nauru' },
  { code: 'nu', dial_code: '+683', name: 'Niue' },
  { code: 'nz', dial_code: '+64', name: 'New Zealand' },
  { code: 'om', dial_code: '+968', name: 'Oman' },
  { code: 'pa', dial_code: '+507', name: 'Panama' },
  { code: 'pe', dial_code: '+51', name: 'Peru' },
  { code: 'pf', dial_code: '+689', name: 'French Polynesia' },
  { code: 'pg', dial_code: '+675', name: 'Papua New Guinea' },
  { code: 'ph', dial_code: '+63', name: 'Philippines' },
  { code: 'pk', dial_code: '+92', name: 'Pakistan' },
  { code: 'pl', dial_code: '+48', name: 'Poland' },
  { code: 'pm', dial_code: '+508', name: 'Saint Pierre and Miquelon' },
  { code: 'pn', dial_code: '+870', name: 'Pitcairn Islands' },
  { code: 'pr', dial_code: '+1-787', name: 'Puerto Rico' },
  { code: 'ps', dial_code: '+970', name: 'Palestine' },
  { code: 'pt', dial_code: '+351', name: 'Portugal' },
  { code: 'pw', dial_code: '+680', name: 'Palau' },
  { code: 'py', dial_code: '+595', name: 'Paraguay' },
  { code: 'qa', dial_code: '+974', name: 'Qatar' },
  { code: 're', dial_code: '+262', name: 'Réunion' },
  { code: 'ro', dial_code: '+40', name: 'Romania' },
  { code: 'rs', dial_code: '+381', name: 'Serbia' },
  { code: 'ru', dial_code: '+7', name: 'Russia' },
  { code: 'rw', dial_code: '+250', name: 'Rwanda' },
  { code: 'sa', dial_code: '+966', name: 'Saudi Arabia' },
  { code: 'sb', dial_code: '+677', name: 'Solomon Islands' },
  { code: 'sc', dial_code: '+248', name: 'Seychelles' },
  { code: 'sd', dial_code: '+249', name: 'Sudan' },
  { code: 'se', dial_code: '+46', name: 'Sweden' },
  { code: 'sg', dial_code: '+65', name: 'Singapore' },
  { code: 'sh', dial_code: '+290', name: 'Saint Helena' },
  { code: 'si', dial_code: '+386', name: 'Slovenia' },
  { code: 'sk', dial_code: '+421', name: 'Slovakia' },
  { code: 'sl', dial_code: '+232', name: 'Sierra Leone' },
  { code: 'sm', dial_code: '+378', name: 'San Marino' },
  { code: 'sn', dial_code: '+221', name: 'Senegal' },
  { code: 'so', dial_code: '+252', name: 'Somalia' },
  { code: 'sr', dial_code: '+597', name: 'Suriname' },
  { code: 'ss', dial_code: '+211', name: 'South Sudan' },
  { code: 'st', dial_code: '+239', name: 'São Tomé and Príncipe' },
  { code: 'sv', dial_code: '+503', name: 'El Salvador' },
  { code: 'sx', dial_code: '+1-721', name: 'Sint Maarten' },
  { code: 'sy', dial_code: '+963', name: 'Syria' },
  { code: 'sz', dial_code: '+268', name: 'Eswatini' },
  { code: 'tc', dial_code: '+1-649', name: 'Turks and Caicos Islands' },
  { code: 'td', dial_code: '+235', name: 'Chad' },
  { code: 'tf', dial_code: '+262', name: 'French Southern Territories' },
  { code: 'tg', dial_code: '+228', name: 'Togo' },
  { code: 'th', dial_code: '+66', name: 'Thailand' },
  { code: 'tj', dial_code: '+992', name: 'Tajikistan' },
  { code: 'tk', dial_code: '+690', name: 'Tokelau' },
  { code: 'tl', dial_code: '+670', name: 'Timor-Leste' },
  { code: 'tm', dial_code: '+993', name: 'Turkmenistan' },
  { code: 'tn', dial_code: '+216', name: 'Tunisia' },
  { code: 'to', dial_code: '+676', name: 'Tonga' },
  { code: 'tr', dial_code: '+90', name: 'Turkey' },
  { code: 'tt', dial_code: '+1-868', name: 'Trinidad and Tobago' },
  { code: 'tv', dial_code: '+688', name: 'Tuvalu' },
  { code: 'tw', dial_code: '+886', name: 'Taiwan' },
  { code: 'tz', dial_code: '+255', name: 'Tanzania' },
  { code: 'ua', dial_code: '+380', name: 'Ukraine' },
  { code: 'ug', dial_code: '+256', name: 'Uganda' },
  { code: 'us', dial_code: '+1', name: 'United States' },
  { code: 'uy', dial_code: '+598', name: 'Uruguay' },
  { code: 'uz', dial_code: '+998', name: 'Uzbekistan' },
  { code: 'va', dial_code: '+39-06', name: 'Vatican City' },
  { code: 'vc', dial_code: '+1-784', name: 'Saint Vincent and the Grenadines' },
  { code: 've', dial_code: '+58', name: 'Venezuela' },
  { code: 'vg', dial_code: '+1-284', name: 'British Virgin Islands' },
  { code: 'vi', dial_code: '+1-340', name: 'United States Virgin Islands' },
  { code: 'vn', dial_code: '+84', name: 'Vietnam' },
  { code: 'vu', dial_code: '+678', name: 'Vanuatu' },
  { code: 'wf', dial_code: '+681', name: 'Wallis and Futuna' },
  { code: 'ws', dial_code: '+685', name: 'Samoa' },
  { code: 'ye', dial_code: '+967', name: 'Yemen' },
  { code: 'yt', dial_code: '+262', name: 'Mayotte' },
  { code: 'za', dial_code: '+27', name: 'South Africa' },
  { code: 'zm', dial_code: '+260', name: 'Zambia' },
  { code: 'zw', dial_code: '+263', name: 'Zimbabwe' },
];

export default countryCodes;
